export function isEnterKeyOrClick(event: KeyboardEvent | MouseEvent): boolean {
  return (
    (event.type === "keydown" && (event as KeyboardEvent).key === "Enter") ||
    event.type === "click"
  );
}
